import { useState } from 'react';
import { Outlet } from 'react-router';

import { Navigate } from '@sorare/routing';
import { ANY_SPORT_SERIES_PLAY } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useShouldUseTraining } from '@sorare/core/src/hooks/commonGame/useIsInTraining';
import { RequireAuth } from '@sorare/core/src/routing/RequireAuth';

const SeriesTrainingLayout = () => {
  const { generateSportContextPath } = useSportContext();
  // only read initial value to avoid unplanned navigation when training is finished
  // (leave that to children components)
  const [initialShouldUseTraining] = useState(useShouldUseTraining());

  if (!initialShouldUseTraining) {
    return (
      <Navigate
        to={generateSportContextPath(ANY_SPORT_SERIES_PLAY)}
        replace
        keepSearchParams
      />
    );
  }

  return (
    <RequireAuth>
      <Outlet />
    </RequireAuth>
  );
};

export default SeriesTrainingLayout;
